// Wrappers de date-fns em pt-BR. Centraliza formatos canonicos para evitar
// strings de formato espalhadas pelo codigo.
//
// Espelha o mobile (`grana-money-app/src/shared/lib/date.ts`).

import { format, isValid, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

/**
 * Converte qualquer entrada (string ISO ou Date) para Date valido. Retorna
 * null se nao parsear. Util para narrow seguro em componentes que recebem
 * data de varias fontes (form, query, props).
 */
export function toDate(input: Date | string | null | undefined): Date | null {
  if (!input) return null;
  if (input instanceof Date) return isValid(input) ? input : null;
  const parsed = parseISO(input);
  return isValid(parsed) ? parsed : null;
}

/** ISO `YYYY-MM-DD` — usado em payloads de API e em filtros de data. */
export function formatISODate(date: Date | string | null | undefined): string {
  const d = toDate(date);
  if (!d) return '';
  return format(d, 'yyyy-MM-dd');
}

/** Formato curto pt-BR para listas/cards (ex: "08 abr 2026"). */
export function formatShortDateBR(date: Date | string | null | undefined): string {
  const d = toDate(date);
  if (!d) return '';
  return format(d, "dd 'de' MMM yyyy", { locale: ptBR });
}

/** "8 de abril" — exibicao de detalhe (sem ano para datas do ano corrente). */
export function formatDayMonthBR(date: Date | string | null | undefined): string {
  const d = toDate(date);
  if (!d) return '';
  return format(d, "d 'de' MMMM", { locale: ptBR });
}

/** "Abril 2026" — usado em month-selector. */
export function formatMonthYearBR(date: Date | string | null | undefined): string {
  const d = toDate(date);
  if (!d) return '';
  const text = format(d, "MMMM 'de' yyyy", { locale: ptBR });
  // Capitaliza primeira letra (date-fns retorna minusculo em pt).
  return text.charAt(0).toUpperCase() + text.slice(1);
}

/** "Hoje", "Ontem" ou data curta. Compactura visual em listas. */
export function formatRelativeBR(date: Date | string | null | undefined): string {
  const d = toDate(date);
  if (!d) return '';
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(d);
  target.setHours(0, 0, 0, 0);
  const diffMs = today.getTime() - target.getTime();
  const oneDay = 24 * 60 * 60 * 1000;
  if (diffMs === 0) return 'Hoje';
  if (diffMs === oneDay) return 'Ontem';
  if (diffMs === -oneDay) return 'Amanha';
  return formatShortDateBR(d);
}
